import styled from 'styled-components';
import { Card as ConstellationCard } from '@zillow/constellation';

export const Card = styled(ConstellationCard)`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: space-around;
  align-items: center;
`;

export const TextContainer = styled.div<{ isSmallScreen: boolean }>`
  max-width: 500px;
  flex-basis: 500px;
  ${(props) => (props.isSmallScreen ? 'text-align: center;' : '')}
`;
